import React from "react"
import { Dialog, DialogTitle, DialogContent, Box, makeStyles, DialogActions, useMediaQuery } from "@material-ui/core"
import { useTheme } from "@material-ui/styles"
import { InlineTitle } from ".."
import { LinkButton } from "../LinkButton"

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: theme.dimensions.dialogs.pickers.width,
    marginLeft: ({ xs }) => (xs ? 0 : null),
    marginRight: ({ xs }) => (xs ? 0 : null),
  },
  title: {
    paddingBottom: theme.spacing(0.5),
  },
  actions: {
    padding: `0 ${theme.spacing(3)}px 29px ${theme.spacing(3)}px`,
  },
  buttons: {
    color: theme.palette.buttons.pickerAction.text,
  },
}))

const SelectorMaster = ({ open, title, form, isInline, onSelect, onCancel }) => {
  const theme = useTheme()
  const xs = useMediaQuery(theme.breakpoints.down("xs"))
  const classes = useStyles({ xs })

  const handleSelect = () => {
    if (onSelect) onSelect()
  }

  const handleCancel = () => {
    if (onCancel) onCancel()
  }

  if (isInline) {
    return (
      <>
        {open && (
          <>
            <InlineTitle>{title}</InlineTitle>
            <Box p={2}>{form}</Box>
          </>
        )}
      </>
    )
  }
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={handleCancel}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
      classes={{ paper: classes.dialog }}
    >
      <>
        <DialogTitle id="form-dialog-title" className={classes.title}>
          {title}
        </DialogTitle>
        <DialogContent>
          <Box ml={-1}>{form}</Box>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Box mr="auto">
            <Box>
              <LinkButton className={classes.buttons} onClick={handleCancel}>
                Cancel
              </LinkButton>
            </Box>
          </Box>
          <Box ml="auto" display="flex" flexDirection="row">
            <Box ml={2}>
              <LinkButton className={classes.buttons} onClick={handleSelect}>
                Select
              </LinkButton>
            </Box>
          </Box>
        </DialogActions>
      </>
    </Dialog>
  )
}

export { SelectorMaster }
